import * as yup from 'yup';

export const newIngresoProductoSchema = yup.object({
  bodega: yup.string().required('Campo Requerido'),
  ubicacion: yup.string().required('Campo Requerido'),
  motivo: yup.string().required('Campo Requerido'),
  unidad_transporte: yup.string().required('Campo Requerido'),
});